import errors from "@/locales/ja/errors.json";
import storages from "@/locales/ja/storages.json";

// API messages are diagnostic input, never display copy. Only local labels are trusted.
const labels: Record<string, string> = {
  ...errors.http,
  ...errors.blockedReasons,
  ...storages.detail.gatewayRouteDeleteErrors,
  ...storages.detail.deleteErrors,
  generic: "操作を完了できませんでした。現在の状態を確認してください。",
  storage_owner_mismatch: "この操作は現在のストレージ設定者だけが実行できます。",
  saved_app_verification_failed: "保存済みのAPIトークンでは、移行先のkintone環境を確認できませんでした。",
  account_trial_concurrency_limit_exceeded: "お試しプランの組織は1アカウントにつき同時に1件のため追加作成できません。",
  revision_conflict: "状態が変更されました。最新状態を取得して確認してください。",
  automatic_alignment_revision_conflict: "状態が変更されました。最新状態を取得して確認してください。",
  automatic_alignment_control_revision_conflict: "状態が変更されました。最新状態を取得して確認してください。",
  alignment_webhook_result_unknown: "操作の結果を確認できません。現在の状態を確認してください。",
  session_expired: errors.http.SESSION_EXPIRED,
  network_error: errors.http.NETWORK_ERROR,
  platform_control_plane_unavailable: "接続先サービスの状態を確認できません。接続状況を確認してください。",
  platform_control_plane_request_failed: "接続先で操作を完了できませんでした。ストレージと接続設定を確認してください。",
  invalid_credentials: "メールアドレスまたはパスワードが正しくありません。",
};

export function apiDisplayMessage(code: string, status: number): string {
  if (Object.hasOwn(labels, code)) return labels[code]!;
  if (status === 401) return errors.http.SESSION_EXPIRED;
  if (status === 403) return "この操作は許可されていません。アカウントの権限を確認してください。";
  if (status === 404) return "対象が見つかりません。画面を更新して確認してください。";
  if (status === 429) return errors.http.RATE_LIMITED;
  if (status === 400 || status === 422) return errors.http.VALIDATION_ERROR;
  if (status === 409) return "現在の状態では操作を完了できません。画面を更新して状態を確認してください。";
  return "処理結果を確認できませんでした。画面で現在の状態を確認し、解消しない場合はお問い合わせください。";
}
